import { render } from "./IndustrySectorsSection.vue?vue&type=template&id=ebc564c8&scoped=true"
import script from "./IndustrySectorsSection.vue?vue&type=script&lang=js"
export * from "./IndustrySectorsSection.vue?vue&type=script&lang=js"

import "./IndustrySectorsSection.vue?vue&type=style&index=0&id=ebc564c8&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebc564c8"]])

export default __exports__